import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const standingsH2HMainContent = style({
  display: "grid",
  gap: vars.space.m,
});
